function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.68333 19.1517C5.44956 19.1513 5.22672 19.0527 5.06916 18.88C4.9087 18.7087 4.82896 18.4771 4.84999 18.2433L5.05416 15.9983L14.4858 6.57L17.4333 9.51667L8.00416 18.9442L5.75916 19.1483C5.73333 19.1508 5.70749 19.1517 5.68333 19.1517ZM18.0217 8.9275L15.075 5.98084L16.8425 4.21334C16.9988 4.05686 17.2109 3.96893 17.4321 3.96893C17.6533 3.96893 17.8654 4.05686 18.0217 4.21334L19.7892 5.98084C19.9456 6.13715 20.0336 6.34925 20.0336 6.57042C20.0336 6.7916 19.9456 7.0037 19.7892 7.16001L18.0225 8.92667L18.0217 8.9275Z",
  fill: "#707274"
});

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/EditPencil.7a2a0ec0.svg";
export { ForwardRef as ReactComponent };